import ApiService from "../../../../services/ApiService";
import translate from "../../../../services/Translate";

export const fetchLatestDemo = (setLatestDemo: Function, setLoading: Function, language: string) => {
  setLoading(true);
  ApiService.get("demos/records/latest")
    .then((response) => setLatestDemo(response.data.demo_record))
    .catch((error) => {
      console.error("Error fetching latest demo:", error);
      alert(translate(language, "ERROR.API_ERROR"));
    })
    .finally(() => setLoading(false));
};
